import { Injectable, signal, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { SessionStorageService } from '../services/session-storage.service';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { EnvironmentService } from '../services/environment.service';
import { Settings } from '../models/training-models';

@Injectable({ providedIn: 'root' })
export class TrainingService {
  private http = inject(HttpClient);
  private ss = inject(SessionStorageService);
  private rbs = inject(RightBridgeApiService);
  private envSvc = inject(EnvironmentService);

  settings;
  environment;
  org;
  rights;
  currentApp = signal('aw');
  private trainingData = new Subject();
  trainingData$ = this.trainingData.asObservable();
  loading: boolean;

  constructor() {
    this.environment = this.envSvc.get();
    this.org = this.environment.org;
    this.rights = this.ss.get('rights');
  }

  load() {
    this.loadSettings();
  }

  get() {
    if (!this.settings) {
      this.loadSettings();
      return this.settings;
    }

    return this.settings;
  }

  loadSettings() {
    const reqHeaders = new HttpHeaders()
      .set('X-RB-S', this.rbs.getSession())
      .set('X-RB-I', 'rb')
      .set('X-RB-O', this.org);
    this.rbs
      .getRequest<Settings>(
        `${this.rbs.baseUrl}/Admin/Training/Settings`,
        reqHeaders
      )
      .subscribe(res => {
        this.trainingData.next(res);
        this.settings = res;
        this.ss.set('training', this.settings);
      });
  }

  rightsValid(courseRights) {
    const rights = this.ss.get('rights');
    let valid = false;

    courseRights.forEach(x => {
      if (rights.includes(x)) {
        valid = true;
      }
    });

    return valid;
  }

  setApp(app) {
    this.currentApp.set(app);
  }
}
